import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import TableNumber from './TableNumber'
import RateIcon from './RateIcon'
import RateText from './RateText'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// register globally
Vue.component('multiselect', Multiselect)
Vue.component('table-number', TableNumber)
Vue.component('rate-icon', RateIcon)
Vue.component('rate-text', RateText)
Vue.component('treeselect', Treeselect)